
const Services = () => {
  return (
    <section
      className="services-section pt-4 pb-4 position-relative"
    >
      <div className="container services-container-inner">
        <div className="section-title-container scroll-animation">
          <h2 className="section-title">GPS Tracking, Geofencing & Route Optimization Services</h2>
          <p className="section-description">
            Access a suite of services including GPS tracking, geofencing, route
            optimization, and SDKs for custom integration. Our APIs and SDKs are
            designed for easy developer integration and scalable deployment,
            empowering you to build location-aware applications efficiently.
          </p>
        </div>

        <div className="row">
          <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
            <div className="feature-box scroll-animation fade-up delay-4 pb-0">
              <div className="feature-icon">
                <i className="fas fa-code"></i>
              </div>
              <h3 className="feature-title">SDK Integration</h3>
              <p className="feature-text">
                Integrate our robust SDKs into your applications for seamless
                access to location services, tracking, and geofencing.
                Accelerate development and customize solutions to fit your
                business needs.
              </p>
            </div>
          </div>
          <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
            <div className="feature-box scroll-animation fade-left delay-1 pb-0">
              <div className="feature-icon">
                <i className="fas fa-map-marker-alt"></i>
              </div>
              <h3 className="feature-title">GPS Tracking</h3>
              <p className="feature-text">
                Cutting-edge GPS tracking solutions that help you monitor and
                manage your assets, vehicles, and personnel with precision. Gain
                real-time insights, improve security, and optimize your
                operations.
              </p>
            </div>
          </div>

          <div className="col-md-6 col-lg-3 mb-4 mb-lg-0">
            <div className="feature-box scroll-animation delay-2 pb-0">
              <div className="feature-icon">
                <i className="fas fa-route"></i>
              </div>
              <h3 className="feature-title">Route Optimization API</h3>
              <p className="feature-text">
                Optimized routes with enhanced efficiency in logistics,
                transportation, and field service operations. Our powerful API
                helps you analyze, plan and optimize routes to save time, reduce
                costs, and improve performance.
              </p>
            </div>
          </div>

          <div className="col-md-6 col-lg-3 mb-4 mb-lg-0 pb-0">
            <div className="feature-box scroll-animation fade-right delay-3">
              <div className="feature-icon">
                <i className="fas fa-draw-polygon"></i>
              </div>
              <h3 className="feature-title">Geofencing</h3>
              <p className="feature-text">
                Set up virtual boundaries and control your assets, vehicles, and
                personnel with enhanced security. Get immediate alerts when
                designated zones are breached and manage your resources more
                effectively.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
